import { DaymapQuery as a } from "../daymapQuery.js";
var s;
((o) => {
  class r extends a {
    constructor() {
      super(
        ["passwordPolicy"],
        null,
        "/lms/api/password/policy",
        null,
        { stale: 1e3 * 60 * 10 }
      );
    }
  }
  o.GetPasswordPolicy = r;
})(s || (s = {}));
export {
  s as passwords
};
//# sourceMappingURL=index.js.map
